export default "__VITE_ASSET__Dl7kJNRf__"